var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_248_646",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_248_646)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 17,
    fill: "#008490"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_248_646",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_248_646",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAA7AAAAOwBeShxvQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAJwSURBVFiFxddNbE1BFAfwX19eFVUsJG0TC6QkPhISgi6xEZFQC2JloQsJG2s7IeysRHytLLoSNux8pWklQnwsbAQhkWgkotqKV2lqMXO5bvte7/X6+CcnN3PmzPnPPTNz5kyT/GjDbmzHeizD4tj3BW/xHHdxCyMFfNdEJy5gDJM5ZQyX0VUP8TycxGgB4qyM4yxaipJ34UUdxFkZQHte8g0YmkXyRN5jXZ4/bwR5Iu9qRWIunjaQPJFBVfbEyX9AnsiZhLQpfjvxCq2pCY3jiXCk6kErNqE543sNXieKC5kZfseWOonT2IpKhuMSIQJt+Ij5qQH3hIyX4DA2FyR9hKup9l1sS7XH0AEHTV2jm9HogBDCFlyZxq6aXIljWqMP0WfWbn8p86dZ7BV27VL04oiwftUwHm1645jB6KMadhBCVS0CfbE9jD1Rt1E4z9kxH9AdbXbic9T3Rd10EXgIn3JMYBITOCHsmw70p/r6o64p2kyk+mpNYKiMhTVClEYJp2IEDglLdy72HRcS2XX05PQHi8oFjBP0YC324VjUrcSNqC+EMr5iScFxq4QNdjS2z8sfyTSGy0IlU3QCIuG1vxiXxpsSntXppB48LwkZ6n/hTlkoIL/5MxUn63lb2CP1oD9+F2X0o9E/QgGZPp8V4QKZLXSbehld5Pd13IWX/rwyf+CxxlzHFawWDsAvnDU1UzVKTk8302Y8+AfkA2qU6e1C9doo8ppFaYJ1DZrEOwVS9RLcn0XyQg+TBC1C9Zo9PkWkImy4OUXJ01ghFJBF3ogjwjlfPpPzppkMUliAXUIdsCE6zz7Pnwqp/bac+eMnQx25tqhpjpQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareEmail);
export default __webpack_public_path__ + "static/media/shareEmail.f96b60de2391baf693b060b3f32fff58.svg";
export { ForwardRef as ReactComponent };